<template>
  <div>
    <SignIn />
  </div>
</template>

<script>
import SignIn from "@/components/SignIn.vue";

export default {
  components: {
    SignIn
  }
};
</script>
